import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { BRANDS } from "@/lib/data";

const BRAND_INFO = {
  BESSEY: "Ferramentas de aperto e sargentos profissionais.",
  BIANDITZ: "Brocas, machos e ferramentas de corte de precisão.",
  BRALO: "Rebites e sistemas de fixação de rebite cego.",
  CETAFORM: "Ferramentas manuais de alta performance.",
  INDEX: "Soluções de fixação para betão e metal.",
  IZAR: "Ferramentas de corte e brocas industriais.",
  "MASTER PROF": "Brocas, serras-copo e acessórios de corte.",
  MUNDIAL: "Alicates e ferramentas manuais italianas.",
  STANLEY: "Ferramentas profissionais de referência mundial.",
  STAYER: "Máquinas elétricas e discos abrasivos.",
  "WD-40": "Lubrificantes e produtos de manutenção multiusos.",
  WIKUS: "Lâminas de serra de alta precisão para indústria.",
};

export default function Marcas() {
  return (
    <div data-testid="marcas-page">
      <section className="relative bg-[#0a0a0a] text-white overflow-hidden">
        <div className="grain absolute inset-0" />
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-32">
          <div className="overline mb-4">Parceiros Selecionados</div>
          <h1 className="font-display font-black uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight max-w-4xl">
            Marcas líderes.<br />
            <span className="text-[#1FA8E0]">Confiança garantida.</span>
          </h1>
          <p className="mt-6 text-white/70 max-w-2xl text-lg">
            Trabalhamos com marcas líderes do mercado, garantindo qualidade e confiança em cada fornecimento.
          </p>
        </div>
      </section>

      <section className="bg-white py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {BRANDS.map((b, i) => (
              <div
                key={b.name}
                data-testid={`brand-card-${b.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="brand-tile p-8 flex flex-col justify-between min-h-[260px] text-left items-start bg-white"
              >
                <div className="font-mono-cet text-xs tracking-widest text-[#1FA8E0]">
                  {String(i + 1).padStart(2, "0")} / {String(BRANDS.length).padStart(2, "0")}
                </div>
                <div className="w-full flex-1 flex items-center justify-center my-6">
                  {b.logo ? (
                    <img
                      src={b.logo}
                      alt={b.name}
                      loading="lazy"
                      className="max-h-24 max-w-full object-contain"
                    />
                  ) : (
                    <div className="font-display font-black text-4xl md:text-5xl text-[#0d4c7d] tracking-wider">
                      {b.name}
                    </div>
                  )}
                </div>
                <div className="text-sm text-[#555] normal-case tracking-normal font-sans">
                  <div className="font-display font-bold text-[#222] uppercase text-base mb-1 tracking-wide">{b.name}</div>
                  {BRAND_INFO[b.name]}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#f5f5f5]">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <div className="overline mb-3">Distribuição Oficial</div>
            <h3 className="font-display font-bold uppercase text-3xl md:text-4xl text-[#0d4c7d]">
              Procura uma marca específica?
            </h3>
          </div>
          <Link to="/contactos" data-testid="marcas-bottom-cta" className="btn-cet btn-dark">
            Consultar Disponibilidade <ArrowUpRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
